import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

export const forcedLogoutGuard: CanActivateFn = () => {
  const authService = inject(AuthServiceLocal);
  if (localStorage.getItem('PWAToken')) {
    authService.userLogout();
  }
  return true;
};
